<app-loader *ngIf="isLogin"></app-loader>
<div class="modal-content2">
  <div class="modal-header">
    <h5 class="modal-title">{{ 'nav.register' | optimizedI18n }}</h5>
    <button
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="onNo()"
    >
      <fa-icon [icon]="faClose"> </fa-icon>
    </button>
  </div>
  <div class="modal-body">
    <!-- <p>
      Accede a una amplia gama de productos,
      <span class="bold">disfruta de beneficios especiales</span> solo para
      miembros. ¡No pierdas <span class="bold">la oportunidad</span> de formar
      parte de esta emocionante
      <span class="bold">comunidad de Kuidadores!</span>
    </p>
    <p>Tu contraseña debe tener las siguientes características:</p>
    <ul>
      <li>Debe contener por lo menos 8 caracteres.</li>
      <li>Debe incluir un número y un carácter especial (*#+!%$”?).</li>
      <li>Debe incluir letra mayúscula y minúscula.</li>
    </ul> -->
    <form [formGroup]="registerFormGroup">
      <div class="form-group">
        <app-input-text
          type="text"
          label="{{ 'form.first_name' | optimizedI18n }}"
          placeholder="{{ 'form.write_here' | optimizedI18n }}"
          frmControl="name"
          class_label="white"
          [formParent]="registerFormGroup"
        ></app-input-text>
      </div>
      <div class="form-group">
        <app-input-text
          type="text"
          label="{{ 'form.last_name' | optimizedI18n }}"
          placeholder="{{ 'form.write_here' | optimizedI18n }}"
          frmControl="lastname"
          class_label="white"
          [formParent]="registerFormGroup"
        ></app-input-text>
      </div>
      <div class="form-group">
        <app-input-text
          type="text"
          label="Número de celular o correo electrónico"
          placeholder="Ingresa tu correo o número de celular"
          frmControl="email"
          class_label="white"
          [formParent]="registerFormGroup"
          (input)="onEmailInput($event)"
        ></app-input-text>
      </div>
      <div class="form-group password-group">
        <app-input-text
          type="{{ typePassword ? 'password' : 'text' }}"
          label="Contraseña"
          placeholder="Contraseña"
          frmControl="password"
          class_label="white"
          [formParent]="registerFormGroup"
        ></app-input-text>
        <label
        class = "password-advice"
        *ngIf="registerFormGroup.get('password')?.valid || !registerFormGroup.get('password')?.dirty"
        [ngStyle]="{'color': registerFormGroup.get('password')?.dirty ? '#567B2D' : '#807F7E'}"
        >
          La contraseña debe tener al menos 8 caracteres, incluyendo una minúscula y un número.
        </label>
      </div>
      <div class="form-group password-group">
        <app-input-text
          type="{{ typePassword ? 'password' : 'text' }}"
          label="Confirmar contraseña"
          placeholder="Contraseña"
          frmControl="passwordConfirm"
          class_label="white"
          [formParent]="registerFormGroup"
        ></app-input-text>
      </div>
      <div class="form-group">
        <div class="form-check d-flex align-items-center">
          <input
            type="checkbox"
            class="form-check-input"
            id="termsAccepted"
            formControlName="termsAccepted"
          />
          <label class="form-check-label textleft">
            <span>Acepto los</span>
            <span class="greem">
              <a href="/home/terms-and-conditions" target="_blank">
                términos y condiciones de uso
              </a>
            </span>
            <span>& las </span>
            <span class="greem">
              <a href="/home/treatment-policy" target="_blank">
                políticas de tratamiento de datos
              </a>
            </span>
          </label>
        </div>
        <div
          *ngIf="
            registerFormGroup.get('termsAccepted')?.hasError('required') &&
            registerFormGroup.get('termsAccepted')?.touched
          "
          class="text-danger"
        >
          Debes aceptar los términos y condiciones.
        </div>
      </div>
      <button
        type="submit"
        class="btn btn-primary btn-block"
        (click)="register()"
        [disabled]="registerFormGroup.invalid || !registerFormGroup.get('termsAccepted')?.value"
      >
        Continuar
      </button>
    </form>
  </div>
</div>
